export interface LeaderboardStep {
  viewIndex: number;
  pageIndex: number;
  pageCount: number;
  dwellSeconds: number;
}

// The rotation sequence: every page of every date range, in order. Each page
// is shown for its range's dwell. A range with no records still gets one page.
const buildSteps = ({
  views,
  documentCounts,
  pageSize,
}: {
  views: DriverLeaderboardDateView[];
  documentCounts: number[];
  pageSize: number;
}): LeaderboardStep[] =>
  views.flatMap((view, viewIndex) => {
    const pageCount = Math.max(
      1,
      Math.ceil((documentCounts[viewIndex] ?? 0) / Math.max(1, pageSize)),
    );
    return Array.from({ length: pageCount }, (_unused, pageIndex) => ({
      viewIndex,
      pageIndex,
      pageCount,
      dwellSeconds: view.dwellSeconds,
    }));
  });

export default buildSteps;
